import { createTheme } from "@mui/material/styles";

// Import Google Font
const interFontFamily = "'Inter', sans-serif";

const theme = createTheme({
  palette: {
    background: {
      default: "#F8FAFC", // ✅ TruEvv page background
      paper: "#FFFFFF",
    },
    text: {
      primary: "#1F2937", // ✅ TruEvv dark text (headings, grid)
      secondary: "#64748B",
    },

    // ✅ PRIMARY — TruEvv Brand Purple
    primary: {
      main: "#5651F4", // TruEvv custom-button / save-button
      50: "#EFEFFD",
      100: "#DEDCFC",
      400: "#7A76F6",
      500: "#5651F4",
      600: "#4A47D8", // TruEvv hover state
      700: "#3F3DB8", // TruEvv deep hover
      800: "#332D8F",
      contrastText: "#FFFFFF",
    },

    // ✅ SECONDARY — TruEvv Peach (add-button)
    secondary: {
      main: "#FFE3DB", // TruEvv add-button
      100: "#FFF3EF",
      400: "#FCDAD3", // TruEvv add-button hover
      500: "#FFE3DB",
      contrastText: "#1E2229", // TruEvv text on peach
    },

    success: {
      main: "#059669", // TruEvv export-button green
      50: "#EEFFE5",
      100: "#D8FFC8",
      300: "#82fc5a",
      400: "#37d80a",
      500: "#059669",
      600: "#047857",
      700: "#065F46",
    },

    info: {
      main: "#3B82F6", // TruEvv edit-button blue
      100: "#DAEBFF",
      400: "#5da8ff",
      500: "#3B82F6",
      600: "#2563EB", // TruEvv edit hover
    },

    warning: {
      main: "#ffc107",
      50: "#fff8e1",
      500: "#ffc107",
      600: "#ffb300",
    },

    // ✅ ERROR — TruEvv Cancel/Delete Reds
    error: {
      main: "#E74C3C", // TruEvv cancel-button
      50: "#FDEDEC",
      100: "#FADBD8",
      150: "#F5B7B1",
      200: "#FFC8C0",
      300: "#ffaa72",
      500: "#E74C3C",
      600: "#C0392B", // TruEvv delete-button
      700: "#A93226", // TruEvv delete hover
    },

    grey: {
      50: "#F9FAFB", // TruEvv row hover
      100: "#F5F5F5", // TruEvv grid header bg
      200: "#E5E7EB", // TruEvv borders
      300: "#b1bbc8",
      400: "#9497aa",
    },

    // ✅ PEACH slot — TruEvv peach family (soft → deep)
    peach: {
      main: "#FFE3DB",
      50: "#FFFAF8",
      100: "#FFF3EF",
      400: "#FCDAD3", // hover
      500: "#FFE3DB",
      600: "#F5C4B8",
      700: "#E8A08C",
      contrastText: "#1E2229",
    },

    // ✅ PURPLE slot — TruEvv brand purple family
    purple: {
      main: "#5651F4",
      50: "#EFEFFD",
      100: "#DEDCFC",
      500: "#5651F4",
      600: "#4A47D8",
      700: "#3F3DB8",
    },
  },
  typography: {
    fontFamily: interFontFamily,
    fontSize: 12.3,
  },
});

export default theme;